import { render, staticRenderFns } from "./QuickNotes.vue?vue&type=template&id=79a8e0df&"
import script from "./QuickNotes.vue?vue&type=script&lang=js&"
export * from "./QuickNotes.vue?vue&type=script&lang=js&"
import style0 from "./QuickNotes.vue?vue&type=style&index=0&id=79a8e0df&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports